import { createFcmExperimentsContext } from 'src/app/shared/contexts/experiment';
import type { LoadedStateData } from 'src/app/shared/utils/async';

export const {
	FcmExperimentsContext: TopicPageFcmExperimentsContext,
	FcmExperimentsProvider: TopicPageFcmExperimentsContextProvider,
	useFcmExperiments: useTopicPageFcmExperiments,
	useAsyncFcmExperiments: useAsyncTopicPageFcmExperiments,
	prefetchFcmExperiments: prefetchTopicPageFcmExperiments,
} = createFcmExperimentsContext({
	name: 'TopicPageFcmExperimentsContext',
	dataProperty: 'pageFcmExperiments',
	configs: {},
	prefetch: true,
});

export type TopicPageFcmExperimentsState = ReturnType<typeof useAsyncTopicPageFcmExperiments>;
export type TopicPageFcmExperiments = LoadedStateData<TopicPageFcmExperimentsState>;
